export default __webpack_public_path__ + "static/media/edit.2e696fb0.svg";